import ContractCreateTable from "./ContractCreateTable";

export default ContractCreateTable;
